import { createContext, useContext } from 'react';

/** 근태 신청 모달(#2c)의 초기 탭. */
export type AttendanceTab = 'punch' | 'leave' | 'trip';

/**
 * 위젯이 보드에 요청할 수 있는 동작 — grid 를 거쳐 prop drilling 하지 않도록 context 로 전달.
 * 위젯은 라우터도 store 도 직접 알 필요가 없다(테스트에서 그대로 갈아끼울 수 있다).
 */
export interface WidgetActions {
  /** 라우트 이동 (예: '/calendar'). */
  go: (to: string) => void;
  /** 근태 신청 모달 열기 (#2c). */
  openAttendanceRequest: (tab?: AttendanceTab) => void;
  /** 개인 설정 모달 열기 (#2e). */
  openSettings: () => void;
}

const noop = () => { /* 기본값 — Provider 밖에서 렌더될 때 조용히 무시. */ };

export const WidgetActionsContext = createContext<WidgetActions>({
  go: noop,
  openAttendanceRequest: noop,
  openSettings: noop,
});

export function useWidgetActions(): WidgetActions {
  return useContext(WidgetActionsContext);
}
